<script lang="ts" setup>
const emit = defineEmits(['closeCatalog']);
const props = defineProps({
  logos: {
    type: Array,
    required: true,
  },
  indexCatalog: {
    type: String,
    required: true,
  },
  isTablet: {
    type: Boolean,
    default: false,
  },
});
const toGo = (e: MouseEvent) => {
  if (props.isTablet) {
    e.preventDefault();
  }
  setTimeout(() => {
    emit('closeCatalog');
  }, 1000);
};
const { $ymGoalEventPromo } = useNuxtApp();
const sendYa = (url: string) => {
  $ymGoalEventPromo('presetMain', url);
};
</script>
<template>
  <div class="logos-wrapper">
    <nuxt-link
      v-for="(logo, index) in logos"
      :key="index"
      :to="`${logo.url}`"
      class="logo-link"
      itemprop="url"
      :event="isTablet ? '' : 'click'"
      @click="
        sendYa(logo.url);
        toGo($event);
      "
    >
      <img :src="logo.image" :alt="logo.title" :class="['logo-img']" />
    </nuxt-link>
  </div>
</template>
<style lang="scss" scoped>
.logos-wrapper {
  display: none;
  margin: 16px 0;
  grid-template-columns: repeat(4, 1fr);
  justify-content: space-between;
  @include md-block {
    display: grid;
  }
  @include xl-block {
    grid-template-columns: repeat(2, 112px);
    grid-gap: 20px 3px;
    margin: 0;
    padding: 0;
    margin-bottom: 64px;
    width: 100%;
  }
  @include xxl-block {
    grid-template-columns: repeat(2, 144px);
    grid-gap: 20px 0;
  }

  .logo-link {
    display: inline-flex;
    width: 100%;
    height: 54px;
    justify-self: center;
    @include dfcc;
    @include xxl-block {
      height: 70px;
    }

    .logo-img {
      width: auto;
      height: 54px;
      object-fit: cover;

      @include xxl-block {
        height: 70px;
      }
    }
  }
}
</style>
